/**
 * Created by tigran on 19.01.25
 **/

import React, { FC } from 'react';
import { IconType } from '@svg/index';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';

export const ForbiddenIcon: FC<IconType> = (props) => {
  const { width, height, color } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2.75C10.0716 2.75 8.18657 3.32183 6.58319 4.39317C4.97981 5.46451 3.73013 6.98726 2.99218 8.76884C2.25422 10.5504 2.06114 12.5108 2.43734 14.4021C2.81355 16.2934 3.74215 18.0307 5.10571 19.3943C6.46927 20.7579 8.20656 21.6865 10.0979 22.0627C11.9892 22.4389 13.9496 22.2458 15.7312 21.5078C17.5127 20.7699 19.0355 19.5202 20.1068 17.9168C21.1782 16.3134 21.75 14.4284 21.75 12.5C21.7473 9.91498 20.7192 7.43661 18.8913 5.60872C17.0634 3.78084 14.585 2.75273 12 2.75ZM20.25 12.5C20.2519 14.4289 19.5745 16.2969 18.3366 17.7762L6.72375 6.1625C7.92844 5.16029 9.39364 4.52191 10.9479 4.32207C12.5022 4.12223 14.0812 4.36919 15.5003 5.03406C16.9193 5.69892 18.1196 6.75418 18.9608 8.07636C19.8019 9.39854 20.2491 10.9329 20.25 12.5ZM3.75 12.5C3.74808 10.5711 4.42551 8.70306 5.66344 7.22375L17.2763 18.8375C16.0716 19.8397 14.6064 20.4781 13.0521 20.6779C11.4978 20.8778 9.91878 20.6308 8.49975 19.9659C7.08072 19.3011 5.88039 18.2458 5.03924 16.9236C4.19809 15.6015 3.7509 14.0671 3.75 12.5Z"
        fill={color}
      />
    </svg>
  );
};
